import React, {Component} from 'react';
import * as api from '../../api';
import { AuthService } from '../../services/auth-service'
import { Grid} from 'semantic-ui-react';

import 'semantic-ui-css/semantic.min.css';
import FilterableDatatable from "../../components/table/filterable-data-table";
import SiteTableMeterHeader from "../meters/meter-table-header";
import SiteTableMeterRow from "../meters/meter-table-row";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import ReactGA from 'react-ga';
import MeterReadsUploadModal from "../meters/meter-reads-modal"


export default class SiteMeterTab extends Component {

    constructor(props) {
        super(props);

        this.authServices = new AuthService();


        this.state = {
            dataProvider: new ApiDataProvider(api.getSitesMeters, [this.props.customerId,this.props.siteKey]),
            isReadOnly : this.authServices.isReadOnly()

        };
    }

    componentDidMount = () => {
       
        ReactGA.pageview('site meters tab');
    };

    render() {
        return (
            <Grid reversed='tablet vertically'>
    <Grid.Row>
      <Grid.Column>               
              {this.state.isReadOnly === false &&
                <MeterReadsUploadModal customerId={this.props.customerId} siteAddress={this.props.siteAddress} siteKey={this.props.siteKey}></MeterReadsUploadModal>
            }
                        
                        </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column><FilterableDatatable dataProvider={this.state.dataProvider}  contextData={{customerId: this.props.customerId}} defaultSort={"id"} headerComponent={SiteTableMeterHeader} rowComponent={SiteTableMeterRow} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
        );
    }
}